import { TConnection } from '../../../../../api/blueprints/connection.template.types';
import { IConfigurePassportDisplayDTO, IConnectionDetailsDTO } from '../../../../../api/connections.dao';
import { withViewModel } from '../../../../../infrastructure/components/with-view-model';
import { PassportConfigurationMode } from './configure-passport-display.config';
import { ConfigurePassportDisplayPresentation } from './configure-passport-display.presentation';
import ConfigurePassportDisplayVM, { IConfigurePassportDisplayFormProps } from './configure-passport-display.viewmodel';

export interface IConfigurePassportDisplayProps {
    props: IConfigurePassportDisplayFormProps;
    connection: IConnectionDetailsDTO;
    passportConfigurationMode: PassportConfigurationMode;
    editBlueprintConnection?: (connection: TConnection) => void;
    blueprintPassportConfiguration?: IConfigurePassportDisplayDTO;
}

export const ConfigurePassportDisplayForm = withViewModel(ConfigurePassportDisplayPresentation,
    (configurePassportDisplayProps: IConfigurePassportDisplayProps) => {
        return new ConfigurePassportDisplayVM(configurePassportDisplayProps);
});
